module.exports = __webpack_public_path__ + "static/img/csm_p2_12646ea39d.ef8d73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fpoe/csm_p2_12646ea39d.png
// module id = 174
// module chunks = 1